import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../Images/circle-info-regular-full.svg'

export default function State ({ localState, setLocalState }) {
  const handleStateChange = event => {
    setLocalState(event.target.value)
  }

  return (
    <div className={styles.locationInputWrapper}>
      {/* Label + Tooltip */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          marginBottom: '8px'
        }}
      >
        <label className={styles.locationLabel} htmlFor='state'>
          State
        </label>
        <Tooltip
          title='Filter by state, province.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='State help'
            width={14}
            height={14}
            style={{ cursor: 'pointer' }}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <input
        className={styles.locationInput}
        type='text'
        id='state'
        autoComplete='off'
        placeholder='Text'
        value={localState}
        onChange={handleStateChange}
      />
    </div>
  )
}
